import { useThemeStore } from "@stores/theme.store";
import { toRp } from "@utils/helper";
import moment from "moment";
import { useEffect } from "react";
import { BsArrowDownLeft, BsArrowUpRight } from "react-icons/bs";
import { useLocation } from "react-router-dom";

export const CheckingAccountDetailPage = () => {
  const { state } = useLocation();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Transaksi",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Transaksi", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <div className="tw-relative tw-z-1 text-center mb-3">
        {state.filter === "IN" ? (
          <BsArrowDownLeft className="tw-bg-white tw-text-green-400 tw-p-2 tw-text-5xl tw-border-4 tw-border-[#435d288a] tw-border-solid tw-rounded-full" />
        ) : (
          <BsArrowUpRight className="tw-bg-white tw-text-red-400 tw-p-2 tw-text-5xl tw-border-4 tw-border-[#435d288a] tw-border-solid tw-rounded-full" />
        )}

        <div className="tw-text-[#fff] mt-2">
          {state?.day != null
            ? moment(state.day).format("dddd, DD MMMM YYYY")
            : "-"}
        </div>

        <div className="tw-text-[#fff] tw-text-2xl tw-font-semibold mb-3">
          {state.filter === "IN" ? toRp(state?.data + 3000) : toRp(state?.data)}
        </div>
      </div>
      <div className="card card-style">
        <div className="content mb-0">
          <div className="tw-text-black dark:tw-text-white tw-text-base">
            Detail Transaksi
          </div>
          {state.transactions.length > 0 &&
            state.transactions.map((item: any, idx: number) => (
              <div key={idx} className="tw-flex tw-justify-between mb-2">
                <div className="color-highlight tw-w-1/2">
                  {item.description}
                </div>
                <div className="color-theme tw-w-1/2 tw-text-right">
                  {toRp(item.nominal)}
                </div>
              </div>
            ))}
          {state.filter === "IN" && (
            <div className="tw-flex tw-justify-between mb-2">
              <div className="color-highlight tw-w-1/2">Biaya Admin Bank</div>
              <div className="color-theme tw-w-1/2 tw-text-right">
                {toRp(3000)}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
